(() => {
  const QUICK_VIEW_SELECTOR = '.product-quick-view__product[data-yagi-discount]';
  const VARIANT_AREA_SELECTOR = 'product-variants';

  function getVariantPrices(quickView) {
    const dataNode = quickView.querySelector('[data-yagi-quick-view-variant-prices]');
    if (!dataNode) return null;

    if (quickView.__yagiVariantPrices) {
      return quickView.__yagiVariantPrices;
    }

    try {
      const parsed = JSON.parse(dataNode.textContent);
      quickView.__yagiVariantPrices = parsed;
      return parsed;
    } catch (error) {
      console.error(
        '[Yagi Quick View] No se pudieron leer los precios de variantes.',
        error
      );
      return null;
    }
  }

  function updatePrice(quickView) {
    if (!quickView) return;

    const discount = Number(quickView.dataset.yagiDiscount || 0);
    if (!(discount > 0)) return;

    const priceContainer = quickView.querySelector(
      '[data-yagi-quick-view-price]'
    );

    const variantInput = quickView.querySelector(
      'product-form input[name="id"]'
    );

    const variants = getVariantPrices(quickView);

    if (!priceContainer || !variantInput || !variants) return;

    const variantId = String(variantInput.value);

    const variant = variants.find(
      item => String(item.id) === variantId
    );

    if (!variant) {
      console.warn(
        '[Yagi Quick View] Variante no encontrada:',
        variantId
      );
      return;
    }

    const original = priceContainer.querySelector(
      '[data-yagi-original]'
    );

    const discounted = priceContainer.querySelector(
      '[data-yagi-discounted]'
    );

    if (original) {
      original.textContent = variant.original;
    }

    if (discounted) {
      discounted.textContent = variant.discounted;
    }

    priceContainer.dataset.yagiVariantId = variantId;
  }

  function scheduleUpdate(quickView) {
    if (!quickView) return;

    /*
     * El theme actualiza primero el input hidden de variante.
     * Usamos varios puntos de sincronización para cubrir:
     * - radio buttons
     * - selects
     * - Quick View cargado por AJAX
     */
    requestAnimationFrame(() => {
      updatePrice(quickView);
    });

    setTimeout(() => {
      updatePrice(quickView);
    }, 40);

    setTimeout(() => {
      updatePrice(quickView);
    }, 100);

    setTimeout(() => {
      updatePrice(quickView);
    }, 200);
  }

  function quickViewFromTarget(target) {
    return target?.closest?.(QUICK_VIEW_SELECTOR) || null;
  }

  /*
   * Cambio real de variante
   */
  document.addEventListener(
    'change',
    event => {
      const quickView = quickViewFromTarget(event.target);

      if (!quickView) return;

      if (event.target.closest(VARIANT_AREA_SELECTOR)) {
        scheduleUpdate(quickView);
      }
    },
    true
  );

  /*
   * Algunos themes primero disparan click sobre
   * label/button y después actualizan la variante.
   */
  document.addEventListener(
    'click',
    event => {
      const quickView = quickViewFromTarget(event.target);

      if (!quickView) return;

      if (event.target.closest(VARIANT_AREA_SELECTOR)) {
        scheduleUpdate(quickView);
      }
    },
    true
  );

  /*
   * El Quick View se inserta dinámicamente por AJAX.
   * Detectamos cualquier modal nuevo.
   */
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches?.(QUICK_VIEW_SELECTOR)) {
          scheduleUpdate(node);
        }

        node
          .querySelectorAll?.(QUICK_VIEW_SELECTOR)
          .forEach(scheduleUpdate);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /*
   * Inicializar Quick Views que ya estén en el DOM
   */
  const initExisting = () => {
    document
      .querySelectorAll(QUICK_VIEW_SELECTOR)
      .forEach(scheduleUpdate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initExisting,
      { once: true }
    );
  } else {
    initExisting();
  }
})();